import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { GalleryCarousel } from '../GalleryCarousel';
export function GallerySection() {
  return <section className="bg-zinc-950 px-5 py-20 md:py-28" data-id="element-126" data-mp="vomu2p2xjs8o">
      <div className="mx-auto max-w-6xl" data-id="element-127" data-mp="qwcyasf4vxyh">
        <SectionHeading title="Mirá todo lo que incluye." data-id="element-128" data-mp="qv1uwtplos7w" />
        <div className="mt-12" data-id="element-129" data-mp="lx0dsebqj2z2">
          <GalleryCarousel data-id="element-130" data-mp="lxrzmxfj5mc5" />
        </div>
      </div>
    </section>;
}